import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import AdminBHULessonProgressCard from 'components/AdminBHULessonProgressCard'
import AdminGradeList from 'components/AdminGradeList'
import AdminLessonProgressCard from 'components/AdminLessonProgressCard'
import AdminLessonProgressTabs from 'components/AdminLessonProgressTabs'
import AdminNoClasses from 'components/AdminNoClasses'
import AdminSiteHeader from 'components/AdminSiteHeader'
import { LESSON_COMPLETION_SPECIALIZED_UNITS_LABEL } from 'components/AdminSiteHeader/constants'
import { SpinnerAnimatedIcon } from 'secondstep-components'
import {
  BodyWrapper,
  LoadingWrapper,
  SingleSiteWrapper,
  StyledHairline,
} from './component.styles'

const AdminSingleSiteView = ({
  isFetchingLessons,
  lessonCompletionUnitsLabel,
  showEmptyDwbReport = false,
  showLessonCompletionExport,
  sites,
  sitesPreferences,
  summary,
}) => {
  if (isFetchingLessons) {
    return (
      <SingleSiteWrapper>
        <LoadingWrapper>
          <SpinnerAnimatedIcon />
          <p>Loading...</p>
        </LoadingWrapper>
      </SingleSiteWrapper>
    )
  }
  if (Array.isArray(sites) && summary) {
    const {
      siteName,
      classesCreated,
      units,
      grades,
      siteId,
      summary: siteSummary,
    } = sites?.[0] || {}
    const hasBHUEnabled =
      sitesPreferences[siteId]?.mspDigital?.bullyingHarassmentUnitEnabled ??
      false
    const hasBHUClassCreated = siteSummary?.unit5?.classesCreated > 0
    const bhuStatus = hasBHUEnabled && hasBHUClassCreated
    const isSpecializedUnits =
      lessonCompletionUnitsLabel === LESSON_COMPLETION_SPECIALIZED_UNITS_LABEL

    return (
      <SingleSiteWrapper>
        <AdminSiteHeader
          classesCreated={summary.classesCreated}
          classesNotStarted={summary.classesNotStarted}
          core={summary.core}
          etlLastUpdatedAt={summary.etlLastUpdatedAt}
          lessonCompletionUnitsLabel={
            lessonCompletionUnitsLabel || 'Core Units'
          }
          lessonsCompleted={summary.lessonsCompleted}
          lessonsTotal={summary.lessonsTotal}
          showLessonCompletionExport={showLessonCompletionExport}
          singleSite
          siteId={siteId}
          siteName={siteName}
          sitesPreferences={sitesPreferences}
          sitesTotal={summary.sitesTotal}
          unit5={summary.unit5}
        />
        {summary?.classesCreated > 0 && !showEmptyDwbReport && (
          <Fragment key="single-site-1">
            <StyledHairline />
            <AdminLessonProgressTabs outline={true} />
          </Fragment>
        )}
        <BodyWrapper
          isDwbEmptyReport={showEmptyDwbReport}
          noClasses={summary?.classesCreated === 0 && !showEmptyDwbReport}
        >
          {(summary?.classesCreated === 0 || showEmptyDwbReport) && (
            <AdminNoClasses isDwbEmptyReport={showEmptyDwbReport} />
          )}
          {summary?.classesCreated > 0 && !showEmptyDwbReport && (
            <Fragment key="single-site-2">
              <AdminLessonProgressCard
                bhuStatus={bhuStatus}
                summary={siteSummary}
                units={units}
              />
              <StyledHairline extraMargin={true} />
              <AdminGradeList
                dwbProgressBars={isSpecializedUnits}
                grades={grades}
                siteId={siteId}
                splitTwoColumns={isSpecializedUnits}
              />
            </Fragment>
          )}
        </BodyWrapper>
        {bhuStatus && (
          <AdminBHULessonProgressCard
            classesCreated={classesCreated}
            grades={grades}
            siteId={siteId}
            summary={siteSummary}
          />
        )}
      </SingleSiteWrapper>
    )
  }
  return null
}

AdminSingleSiteView.propTypes = {
  isFetchingLessons: PropTypes.bool,
  lessonCompletionUnitsLabel: PropTypes.string.isRequired,
  showEmptyDwbReport: PropTypes.bool,
  showLessonCompletionExport: PropTypes.bool,
  sites: PropTypes.array,
  sitesPreferences: PropTypes.object,
  summary: PropTypes.object,
}

export default AdminSingleSiteView
